export default __webpack_public_path__ + "static/media/icon-Growyx.a827b082.svg";